import { snapshot } from 'valtio';

import { Permission, PermissionComponent, PermissionDiagram, PermissionProject } from 'models';

import { permissionsState } from 'state/current-project-permissions';

const PermissionService = {
    check: (permissions: Permission[], permission: Permission | Permission[]) => {
        if (Array.isArray(permission)) {
            return permission.some((permission) => permissions.includes(permission));
        }

        if (permission.includes('project') && permissions.includes(PermissionProject.ALL)) return true;
        if (permission.includes('project') && permissions.includes(PermissionProject.ADMIN)) return true;

        if (permission.includes('component') && permissions.includes(PermissionComponent.ALL)) return true;

        return permissions.includes(permission);
    },

    // This belongs in a service.
    can: (toCheck: PermissionDiagram): boolean => {
        const permissions = snapshot(permissionsState).permissions;

        return permissions[toCheck] ?? false;
    },
};

export { PermissionService };
